import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function Administration() {
  const isMobile = window.innerHeight > window.innerWidth;
  const mainStyle = { textAlign: 'left' };

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull" style={mainStyle}>
            <h1>Administration</h1>
            <Paper style={mainStyle}>
              <h2>Les Outils</h2>
              <h3>CRM: Dolibarr</h3>
              Le CRM est disponible ici: <a href="http://syncstats.ddns.net/dolibarr/htdocs">syncstats.ddns.net/dolibarr/htdocs</a>
              <h3>Gestion des finances</h3>
              Le site de gestion des finances est ici: <a href="https://www.waveapps.com/">waveapps.com/</a>
            </Paper>
            <Paper style={mainStyle}>
              <h2>Dates Importantes</h2>
              <h3>Q1</h3>
              <List component="nav" aria-label="secondary mailbox folders"><ListItem><ListItemText primary="15 Janvier: Date limite DAS pour Q4" /></ListItem></List>
              <h3>Q2</h3>
              <List component="nav" aria-label="secondary mailbox folders"><ListItem><ListItemText primary="15 avril: Date limite DAS pour Q1" /></ListItem></List>
              <h3>Q3</h3>
              <List component="nav" aria-label="secondary mailbox folders"><ListItem><ListItemText primary="15 juillet: Date limite DAS pour Q2" /></ListItem></List>
              <h3>Q4</h3>
              <List component="nav" aria-label="secondary mailbox folders"><ListItem><ListItemText primary="15 octobre: Date limite DAS pour Q3" /></ListItem></List>
            </Paper>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Administration;



// WEBPACK FOOTER //
// src/components/Administration.js